/**
 * Decide whether analytics should be initialised, based on three inputs
 * (highest precedence first):
 *
 *   1. personalOverride ("on" | "off" | null) — per-browser localStorage
 *      escape hatch. Wins over everything so a dev can force session replay
 *      on locally without flipping it for other users. Not exposed in the
 *      admin UI; set manually via DevTools.
 *   2. serverValue ("on" | "off" | null) — env-wide admin setting from
 *      /api/v1/system/settings/analytics. When present, every user on this
 *      environment respects it. null means "no admin has ever set it →
 *      use the env default below".
 *   3. environment default — prod_bloomberg / prod_consignment: ON; every
 *      other env (dev, dev_consignment, local, unknown): OFF. Protects the
 *      PostHog free-tier quota from idle dev traffic while keeping prod
 *      instrumented by default.
 *
 * Pure function so the decision is testable without touching localStorage
 * or the bootstrap side effects.
 *
 * @param {string} environment  REACT_APP_POSTHOG_ENV value
 * @param {"on" | "off" | null | undefined} personalOverride
 * @param {"on" | "off" | null | undefined} serverValue
 * @returns {boolean}
 */
export const decideAnalyticsEnabled = (environment, personalOverride, serverValue) => {
  if (personalOverride === "on") return true;
  if (personalOverride === "off") return false;
  if (serverValue === "on") return true;
  if (serverValue === "off") return false;
  const isProd =
    environment === "prod_bloomberg" || environment === "prod_consignment";
  return isProd;
};

export const ANALYTICS_OVERRIDE_STORAGE_KEY = "clipn:analytics-override";
